import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/EPDMCalculator/epdmCalculator.container"
    ).then((module) => ({ default: module.EPDMCalculator }))
);
